module.exports = __webpack_public_path__ + "static/img/HUDSON.603743a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/HUDSON.jpg
// module id = cMUK
// module chunks = 0